import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/myngle.webp';
import screenshot_target from '../../../images/letterfunnel/marinatognetti.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Marina Tognetti"
      firstname="Marina"
      companyname="Myngle"
      competition="Speexx en Preply Business"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/marinatognetti.js